exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col1[data-v-91833058] {\n  width: 280px;\n}\n.col2[data-v-91833058] {\n  width: 140px;\n  text-align: right;\n  font-weight: bold;\n}\n.col3[data-v-91833058] {\n  width: 250px;\n  padding-left: 10px;\n}\n", ""]);

// exports
